import v from 'voca';

import { parseBoolean } from '../utils/parserUtils';

function isEnabled() {
  const isDisabled = parseBoolean(process.env.GATSBY_PENDO_DISABLED);
  if (isDisabled) return false;

  return !v.isBlank(process.env.GATSBY_PENDO_API_KEY);
}

function setUser(currentUser) {
  if (!isEnabled()) return;

  if (!window.pendo) return;

  window.pendo.initialize({
    visitor: {
      id: currentUser.id,
      name: currentUser.name,
      email: currentUser.email,
    },
    account: {
      id: currentUser.company.id,
      name: currentUser.company.name,
    },
  });
}

function clearUser() {
  if (!isEnabled()) return;

  if (!window.pendo) return;

  window.pendo.clearSession();
}

export default { isEnabled, setUser, clearUser };
